import NoReplyIcon from 'components/atoms/icon/NoReplyIcon';
import ReplyHappyIcon from 'components/atoms/icon/ReplyHappyIcon';
import ReplySadIcon from 'components/atoms/icon/ReplySadIcon';
import ReplyVeryHappyIcon from 'components/atoms/icon/ReplyVeryHappyIcon';
import ReplyVerySadIcon from 'components/atoms/icon/ReplyVerySadIcon';
import ReplyWowIcon from 'components/atoms/icon/ReplyWowIcon';
import React from 'react';
import {
  TIconProps,
  TListIconProps,
  TRatingIconLabel,
  TRatingTypeID,
  TRatingTypeIDNumber,
  TRatingTypeName,
} from './type';

export const MIN_ANSWER_ROW = 1;

export const DEFAULT_ANSWER_INFO = {
  answerID: '',
  answerContent: '',
  imagePath: '',
  nextQuestion: '',
  isOther: false,
  objFile: null,
  isDeleteImage: false,
  numericalOrder: 0,
  isHaveImage: false,
  haveUpdateImage: false,
  isExistImg: false,
  isExistUrl: '',
};

export const DEFAULT_ROW_MATRIX_INFO = {
  answerRowID: '',
  questionID: '',
  answerRowContent: '',
  imagePath: '',
  objFile: null,
  isDeleteImage: false,
  isOther: false,
};

export const DEFAULT_COLUMN_MATRIX_INFO = {
  answerColumnID: '',
  answerRowID: '',
  answerColumnContent: '',
  isDropDown: false,
  imagePath: '',
  objFile: null,
  isDeleteImage: false,
  isOther: false,
};

export const DEFAULT_ROW_MATRIX_LIST_INFO = {
  answerRowID: '',
  questionID: '',
  answerRowContent: '',
  isDropDown: false,
  imagePath: '',
  objFile: null,
  isDeleteImage: false,
  isOther: false,
};

export const DEFAULT_COLUMN_MATRIX_LIST_INFO = {
  answerColumnID: '',
  answerRowID: '',
  answerColumnContent: '',
  isDropDown: false,
  listMatrixCategories: [
    {
      matrixCategoryID: '',
      answerColumnID: '',
      matrixCategoryName: '',
    },
  ],
  imagePath: '',
  objFile: null,
  isDeleteImage: false,
  isOther: false,
};

export const RATING_TYPE_ID: Record<TRatingTypeName, TRatingTypeID> = {
  WOW: '1',
  KPI: '2',
  STAR: '3',
  NUMBER: '4',
  EX_1: '5',
  EX_2: '6',
  EX_3: '7',
};

export const RATING_TYPE_ID_NUMBER: Record<TRatingTypeName, TRatingTypeIDNumber> = {
  WOW: 1,
  KPI: 2,
  STAR: 3,
  NUMBER: 4,
  EX_1: 5,
  EX_2: 6,
  EX_3: 7,
};

export const RATING_MAX_LEVEL: Record<string, number> = {
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  TEN: 10,
};

export const RATING_TYPE_5_DESCRIPTION: Record<string, string> = {
  '1': 'Không đánh giá được',
  '2': 'Rất không đồng ý',
  '3': 'Không đồng ý',
  '4': 'Bình thường',
  '5': 'Đồng ý',
  '6': 'Rất đồng ý',
};

export const RATING_TYPE_6_DESCRIPTION: Record<string, string> = {
  '1': 'Không đánh giá được',
  '2': 'Rất không hài lòng',
  '3': 'Không hài lòng',
  '4': 'Bình thường',
  '5': 'Hài lòng',
  '6': 'Rất hài lòng',
};

export const RATING_SELECTED_COLOR: Record<string, string> = {
  '1': '#A12200',
  '2': '#C80024',
  '3': '#E5781D',
  '4': '#F0B71C',
  '5': '#68CD2F',
  '6': '#00A907',
};

export const RATING_DEFAULT_COLOR = '#D8D8D8';

export const RATING_ICON_LABEL: Record<TRatingIconLabel, string> = {
  noReply: 'No Reply',
  verySad: 'Very Sad',
  sad: 'Sad',
  happy: 'Happy',
  veryHappy: 'Very Happy',
  wow: 'Wow',
};

// Type G-Wow(1)
export const listIconQuestionRatingType1: Record<string, React.FC<TIconProps>> = {
  '1': ReplyVerySadIcon,
  '2': ReplySadIcon,
  '3': ReplyHappyIcon,
  '4': ReplyVeryHappyIcon,
  '5': ReplyWowIcon,
};

// Type KPI(2)
export const listIconQuestionRatingType2: Record<string, React.FC<TIconProps>> = {
  '1': ReplyVerySadIcon,
  '2': ReplySadIcon,
  '3': ReplyHappyIcon,
  // '4': ReplyVeryHappyIcon,
};

//Type Ex-Đồng ý(5), Ex-Hài lòng(6), G-Wow NA(7)
export const listIconQuestionRatingType5Type6Type7: Record<string, React.FC<TIconProps>> = {
  '1': NoReplyIcon,
  '2': ReplyVerySadIcon,
  '3': ReplySadIcon,
  '4': ReplyHappyIcon,
  '5': ReplyVeryHappyIcon,
  '6': ReplyWowIcon,
};

// Render question rating has icon(1,2,5,6,7)
export const renderListIcon: Record<number, TListIconProps> = {
  1: listIconQuestionRatingType1,
  2: listIconQuestionRatingType2,
  5: listIconQuestionRatingType5Type6Type7,
  6: listIconQuestionRatingType5Type6Type7,
  7: listIconQuestionRatingType5Type6Type7,
};

export const questionRatingTooltipConfig: Record<number, boolean> = {
  1: false,
  2: false,
  3: false,
  4: false,
  5: true,
  6: true,
  7: false,
};

export const questionRatingTooltipInfo: Record<number, Record<string, string>> = {
  5: RATING_TYPE_5_DESCRIPTION,
  6: RATING_TYPE_6_DESCRIPTION,
};

export const renderQuestionRatingType3Type4: Record<number, boolean> = {
  3: true,
  4: true,
};
